<template>
  <div style="padding:20px;">
    <el-row :gutter="20">
<!--      <el-skeleton :loading="dataLoading" animated>
        <template slot="template">
          <div style="padding:0 10px 24px">
            <el-skeleton-item variant="h3" style="width:200px"/>
            <el-skeleton-item variant="p" style="margin: 15px 0 0 0" />
            <el-skeleton-item variant="p" style="margin: 15px 0 0 0" />
            <el-skeleton-item variant="p" style="margin: 15px 0 0 0" />
          </div>
        </template>-->
        <template>
          <el-col :span="24">
            <h2 style="margin-top: 0;">脉轮活动管理</h2>
          </el-col>
<!--          <el-col :span="24">
            <el-row :gutter="20" style="border-radius: 4px">
              <el-col :span="4">
                <el-descriptions title="" :column="1" size="medium">
                  <el-descriptions-item label="活动来源用户">
                    <el-tooltip class="item" effect="dark" content="用户来源为 助力活动 的用户数量" placement="bottom">
                      <span>{{ backendData.activity_source_user }}</span>
                    </el-tooltip>
                  </el-descriptions-item>
                  <el-descriptions-item label="新用户助力人数">{{ backendData.assist_new_user }}</el-descriptions-item>
                </el-descriptions>
              </el-col>
              <el-col :span="4">
                <el-descriptions title="" :column="1" size="medium">
                  <el-descriptions-item label="新用户APP助力人数">{{ backendData.app_new_user }}</el-descriptions-item>
                  <el-descriptions-item label="新用户H5助力人数">{{ backendData.wap_new_user }}</el-descriptions-item>
                </el-descriptions>
              </el-col>
              <el-col :span="4">
                <el-descriptions title="" :column="1" size="medium">
                  <el-descriptions-item label="奖学金活动发起人次">{{ backendData.create_log }}</el-descriptions-item>
                  <el-descriptions-item label="奖学金有效发起人次">{{ backendData.create_valid_log }}</el-descriptions-item>
                </el-descriptions>
              </el-col>
              <el-col :span="4">
                <el-descriptions title="" :column="1" size="medium">
                  <el-descriptions-item label="奖学金活动参与总人次">
                    <el-tooltip class="item" effect="dark" content="抽奖总次数" placement="bottom">
                      <span>{{ backendData.lottery_log }}</span>
                    </el-tooltip>
                  </el-descriptions-item>
                  <el-descriptions-item label="奖学金活动参与总人数">
                    <el-tooltip class="item" effect="dark" content="抽奖总人数" placement="bottom">
                      <span>{{ backendData.lottery_people }}</span>
                    </el-tooltip>
                  </el-descriptions-item>
                </el-descriptions>
              </el-col>
              <el-col :span="4">
                <el-descriptions title="" :column="1" size="medium">
                  <el-descriptions-item label="奖学金激活成功总人数">{{ backendData.create_success_log }}</el-descriptions-item>
                  <el-descriptions-item label="奖学金活动助力总人次">{{ backendData.partake_log }}</el-descriptions-item>
                </el-descriptions>
              </el-col>
              &lt;!&ndash; <el-col :span="12">
                <el-descriptions title="" :column="1" direction="vertical" size="medium">
                  <el-descriptions-item label="福袋领取记录">
                    <el-descriptions title="" :column="8" size="medium" >
                      <template v-for="(item,index) in backendData.lock_bag_log">
                        <el-descriptions-item v-bind:key="index" :label="item.received_luck_bag"><b>{{item.num}}</b></el-descriptions-item>
                      </template>
                    </el-descriptions>
                  </el-descriptions-item>
                </el-descriptions>
              </el-col> &ndash;&gt;
            </el-row>
            <el-divider></el-divider>
          </el-col>-->
        </template>
<!--      </el-skeleton>-->
      <el-col :span="24">
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
          <el-tab-pane label="活动管理" name="dataList">
            <el-row style="margin-bottom: 10px;">
              <el-button type="primary" size="small" @click="addActivity()">增加活动</el-button>
            </el-row>
            <el-table :data="listData" style="width: 100%" border  v-loading="listLoading" >
              <el-table-column prop="id" label="ID" width="90"></el-table-column>
              <el-table-column prop="lottery_give_title" label="奖品名称"></el-table-column>
              <el-table-column prop="lottery_give_num" label="抽奖奖品数量"></el-table-column>
              <el-table-column label="期号" width="90">
                <template slot-scope="{row}">
                  <span>第{{row.stage}}期</span>
                </template>
              </el-table-column>
              <el-table-column label="时间" width="100">
                <template slot-scope="{row}">
                  <div>{{ row.start_at }}</div>
                  <div>{{ row.end_at }}</div>
                </template>
              </el-table-column>
              <el-table-column label="状态" width="90">
                <template slot-scope="{row}">
                  <span style="color:rgb(103, 194, 58)" v-if="row.status == 1">上架中</span>
                  <span style="color:#909399" v-else>已下架</span>
                </template>
              </el-table-column>
              <el-table-column label="活动信息">
                <template slot-scope="{row}">
                  <div>新人要求数：<b>{{ row.new_user_num }}</b></div>
                  <div>奖码起始值：<b>{{ row.lottery_code_start }}</b></div>
                </template>
              </el-table-column>
              <el-table-column label="猜你喜欢">
                <template slot-scope="{row}">
                  <div>课程ID：<b>{{ row.course_ids }}</b></div>
                  <div>商品ID：{{ row.product_ids }}</div>
                </template>
              </el-table-column>
              <!-- <el-table-column label="奖品图片" width="100">
                <template slot-scope="{row}">
                  <el-image style="width: 75px; height: 50px" :src="row.give_img_url" fit="cover" :preview-src-list="[row.give_img_url]"></el-image>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="奖品价格">
                <template slot-scope="{row}">
                  <div>奖品划线价：<b>{{ row.give_scribing_price }}</b></div>
                  <div>奖品价格：<b>{{ row.give_price }}</b></div>
                </template>
              </el-table-column> -->
              <el-table-column label="福袋">
                <template slot-scope="{row}">
                  <div>福袋ID：<b>{{ row.lucky_bag_ids }}</b></div>
                  <div>福袋优惠券ID：{{ row.lucky_bag_extra_ids }}</div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="{row}">
                  <el-button type="primary" size="small" @click="updateChakras(row.id)">修改</el-button>
                  <template v-if="row.status == 1">
                    <el-button type="danger" size="small" @click="updateChakrasOnline(row.id, 'offline')">下架</el-button>
                  </template>
                  <template v-else>
                    <el-button type="success" size="small" @click="updateChakrasOnline(row.id, 'online')">上架</el-button>
                  </template>
                  <template v-if="row.status == 0">
                    <el-button type="danger" size="small" @click="chakrasDelete(row.id)">删除</el-button>
                  </template>
                  <el-button type="primary" size="small" @click="addWinner(row.id)">设置中奖人</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>

          <!--活动数据-->
          <el-tab-pane label="活动数据" name="chakrasData">
            <el-row style="margin-bottom: 10px;">
              <el-date-picker class="search-el" size="small" v-model="query.start_end_at" value-format='yyyy-MM-dd HH:mm:ss' type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
              <el-button type="primary" size="mini" @click="getChakrasDataList()">
                查询
              </el-button>
            </el-row>
            <el-table :data="chakrasDataList" style="width: 100%" border  v-loading="chakrasDataListLoading" >
              <el-table-column prop="id" label="ID" width="90"></el-table-column>
              <el-table-column prop="title" label="标题"></el-table-column>
              <el-table-column label="期号" width="90">
                <template slot-scope="{row}"> <span>第{{row.stage}}期</span> </template>
              </el-table-column>
              <el-table-column label="时间" width="170">
                <template slot-scope="{row}"> <span>{{row.start_at}}~{{row.end_at}}</span> </template>
              </el-table-column>
              <el-table-column prop="participate_users_num" label="参与人数"></el-table-column>
              <el-table-column prop="participate_users_times_num" label="参与人次"></el-table-column>
              <el-table-column prop="create_user_num" label="发起人数"></el-table-column>
              <el-table-column prop="create_user_times_num" label="发起人次"></el-table-column>
              <el-table-column prop="invited_users_num" label="被邀请人次"></el-table-column>
              <el-table-column prop="invite_new_user_num" label="新用户人数"></el-table-column>
              <el-table-column prop="success_team_num" label="成功组数"></el-table-column>
              <el-table-column prop="success_user_times_num" label="成功人次"></el-table-column>
              <el-table-column prop="received_luck_bag_num" label="体验营领取"></el-table-column>
            </el-table>
          </el-tab-pane>

          <!--用户数据-->
          <el-tab-pane label="用户数据" name="userData">
            <el-row style="margin-bottom: 10px;">
              <el-date-picker class="search-el" size="small" v-model="query.team_start_at" value-format='yyyy-MM-dd HH:mm:ss' type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
              <el-button type="primary" size="small" @click="getUserDataList()">
                查询
              </el-button>
            </el-row>
            <el-table :data="userDataList" style="width: 100%" border  v-loading="userDataListLoading" >
              <el-table-column label="期号" width="90">
                <template slot-scope="{row}"> <span>{{row.stage}}</span> </template>
              </el-table-column>
              <el-table-column label="时间" width="170">
                <template slot-scope="{row}"> <span>{{row.start_at}}~{{row.end_at}}</span> </template>
              </el-table-column>
              <el-table-column prop="nickname" label="发起人昵称"></el-table-column>
              <el-table-column prop="mobile_phone" label="手机号"></el-table-column>
              <el-table-column prop="team_start_at" label="发起时间"></el-table-column>
              <el-table-column prop="now_user_num" label="当前人数"></el-table-column>
              <el-table-column prop="team_times" label="累计组队次数"></el-table-column>
              <el-table-column prop="status" label="状态"></el-table-column>
            </el-table>
            
            <div style="margin-top:10px">
              <el-pagination background @current-change="getUserDataList" :current-page.sync="query.page" :page-size="query.limit"
                            layout="total, prev, pager, next, jumper" :total="userDataListTotal">
              </el-pagination>
            </div>
          </el-tab-pane>

          <!--福袋数据-->
          <el-tab-pane label="福袋数据" name="luckBagData">
            <el-row style="margin-bottom: 10px;">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-date-picker size="small" v-model="lockBagQuery.date" value-format="yyyy-MM-dd" type="date" placeholder="领取时间" ></el-date-picker>
                  <el-button type="primary" size="small"  style="margin-left: 10px;" @click="getLockBagList()">
                    查询
                  </el-button>
                </div>
              </el-col>

              <el-col :span="8"><div class="grid-content bg-purple-light" style="margin-left: 25em"><span class="cell">累计领取：{{this.TotalReceivedNum}}</span></div></el-col>
              <el-col :span="8"><div class="grid-content bg-purple-light"><span class="cell">新用户累计领取：{{this.TotalNewUserReceivedNum}}</span></div></el-col>

            </el-row>
            <el-table :data="lockBagList" style="width: 100%" border  v-loading="lockBagListLoading" >
<!--              <el-table-column prop="chakras_id" label="活动ID" width="90"></el-table-column>-->
              <el-table-column prop="received_luck_bag" label="体验营ID"></el-table-column>
              <el-table-column label="开课时间" width="170">
                <template slot-scope="{row}"> <span>{{row.course_begin_at}}~{{row.course_end_at}}</span> </template>
              </el-table-column>
              <el-table-column prop="course_name" label="课程"></el-table-column>
              <el-table-column prop="num" label="领取数量"></el-table-column>
              <el-table-column prop="received_new_user_num" label="新用户领取数量"></el-table-column>
            </el-table>
          </el-tab-pane>

          <!--中奖名单-->
          <el-tab-pane label="中奖名单" name="userWinningData">
            <el-row style="margin-bottom: 10px;">
              <el-select class="search-el" clearable size="small" v-model="query.stage" placeholder="助学金期号">
                <el-option label="不限" value="0"></el-option>
                <template v-for="(item,index) in stageList">
                  <el-option v-bind:key="index" :label="'第' + item.stage + '期'" :value="item.stage"></el-option>
                </template>
              </el-select>
              <el-button type="primary" size="small" @click="getUserWinningList()">
                查询
              </el-button>
            </el-row>
            <el-table :data="userWinningList" style="width: 100%" border  v-loading="userWinningListLoading" >
              <el-table-column label="期号" width="90">
                <template slot-scope="{row}"> <span>{{row.stage}}</span> </template>
              </el-table-column>
              <el-table-column label="时间" width="170">
                <template slot-scope="{row}"> <span>{{row.start_at}}~{{row.end_at}}</span> </template>
              </el-table-column>
              <el-table-column prop="nickname" label="中奖人昵称"></el-table-column>
              <el-table-column prop="avatar" label="头像" width="170">
                <template slot-scope="{row}">
                  <img  :src="row.avatar" alt="" style="width: 50px;height: 50px">
                </template>

              </el-table-column>
              <el-table-column prop="mobile_phone" label="手机号"></el-table-column>
              <el-table-column prop="team_times" label="累计发起组队次数"></el-table-column>
              <el-table-column prop="new_user_num" label="累计拉新人数"></el-table-column>
              <el-table-column label="累计消费金额" width="90">
                <template slot-scope="{row}"> <span>￥{{row.stage}}</span> </template>
              </el-table-column>
              <el-table-column prop="lottery_code" label="中奖码"></el-table-column>
            </el-table>

            <div style="margin-top:10px">
              <el-pagination background @current-change="getUserDataList" :current-page.sync="query.page" :page-size="query.limit"
                             layout="total, prev, pager, next, jumper" :total="userWinningTotal">
              </el-pagination>
            </div>
          </el-tab-pane>

        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getList, getChakrasDataList, getUserDataList, getLockBagList, updateChakrasOnline, chakrasDelete,getUserWinningList
} from "@/api/activityChakras";
/*import { setTimeout } from 'timers';*/

export default {
  data: function() {
    return {
      platformList:{
        0:'H5',
        1:'Android',
        2:'IOS',
        3:'H5',
      },
      userLevelList:[],
      stageList:[],
      query:{
        level_id:'',
        create_platform:'',
        platform:'',
        stage:'',
        page:1,
        limit:20,
        start_end_at:'',
        team_start_at:'',
      },
      activeName: 'dataList',
      dataLoading:true,
      listLoading:true,
      /*backendData:{
        activity_source_user: 0,
        app_new_user: 0,
        wap_new_user: 0,
        assist_new_user: 0,
        create_log: 0,
        create_success_log: 0,
        create_valid_log: 0,
        lottery_log: 0,
        lottery_people: 0,
        partake_log: 0,
        lock_bag_log:[],
      },*/
      listData:[],
      chakrasDataList:[],
      chakrasDataListLoading:true,
      userDataList:[],
      userDataListLoading:true,
      userDataListTotal:0,
      lockBagList:[],
      lockBagListLoading:true,
      TotalReceivedNum:0,
      TotalNewUserReceivedNum:0,
      userWinningList:[],
      userWinningListLoading:true,
      userWinningTotal:0,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      lockBagQuery:{
        date:'',
      },
    };
  },
  created: function() {
    /*this.getData();*/
    this.getList();
  },
  methods: {
    /*getData(){
      this.dataLoading = true;
      getData().then(response => {
        let that = this
        this.backendData = response.data.backend_data
        setTimeout(function(){
          that.dataLoading = false;
        }, 500);
      });
    },*/
    getList(){
      this.listLoading = true;
      getList().then(response => {
        this.listData = response.data.list
        this.listLoading = false;
      });
    },
    getChakrasDataList(){
      this.chakrasDataListLoading = true;
      getChakrasDataList(this.query).then(response => {
        this.chakrasDataList = response.data.list
        this.chakrasDataListLoading = false;
      });
    },
    getUserDataList(){
      this.userDataListLoading = true;
      getUserDataList(this.query).then(response => {
        this.userDataList = response.data.list
        this.userLevelList = response.data.user_level_list
        this.stageList = response.data.stage_list
        this.userDataListTotal = response.data.total;
        this.userDataListLoading = false;
      });
    },
    updateChakras(id){
      this.$router.push({
        path: "/activity/chakras/info",
        query: {type:'update', id:id}
      });
    },
    addActivity(){
      this.$router.push({
        path: "/activity/chakras/info",
        query: {type:'create'}
      });
    },
    addWinner(id){
      this.$router.push({
        path: "/activity/chakras/winner",
        query: {activity_id:id,winning_status:1}
      });
    },
    getLockBagList(){
      this.lockBagListLoading = true;
      getLockBagList(this.lockBagQuery).then(response => {
        this.TotalReceivedNum = 0;
        this.TotalNewUserReceivedNum = 0;
        this.lockBagList = response.data;
        response.data.forEach(item =>{
          this.TotalReceivedNum += item.num
          this.TotalNewUserReceivedNum += item.received_new_user_num
        })
        this.lockBagListLoading = false;
      });
    },
    getUserWinningList(){
      this.userWinningListLoading = true;
      getUserWinningList(this.query).then(response => {
        this.userWinningList = response.data.list
        this.stageList = response.data.stage_list
        this.userWinningTotal = response.data.total;
        this.userWinningListLoading = false;
      });
    },
    updateChakrasOnline(id,type){
      this.listLoading = true;
      updateChakrasOnline({id,type}).then(response => {
        this.listLoading = false;
        if(response.code == 1){
          this.getList();
          this.$message({
            showClose: true,
            duration: 6000,
            message: '修改成功',
            type: 'success'
          });
        }
      });
    },
    chakrasDelete(id){
      this.$confirm('此操作将删除活动信息，是否确认操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        chakrasDelete({id}).then(response => {
          this.listLoading = false;
          if(response.code == 1){
            this.getList();
            this.$message({
              showClose: true,
              duration: 6000,
              message: '删除成功',
              type: 'success'
            });
          }
        });
      }).catch(() => {

      });
      
    },
    handleClick(tab) {
      switch (tab.name) {
        case 'dataList':
          this.getList();
          break;
        case 'chakrasData':
          this.getChakrasDataList();
          break;
        case 'userData':
          this.getUserDataList();
          break;
        case 'luckBagData':
          this.getLockBagList();
          break;
        case 'userWinningData':
          this.getUserWinningList();
          break;
      }
    },
  }
};
</script>

